import React, { useMemo } from 'react';
import { Modal, Slide } from '@material-ui/core';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { selectChatInterfaceState, selectCurrentSelectedChat } from 'models/twilio';
import { POSITIONING, scrollBarStyles } from 'components/twilio/constants';
import ConversationList from '../ConversationList';
import ChatInterface from '../ChatInterface';
import MobileChatHeader from './MobileChatHeader';
import ChatSnackbar from '../ChatSnackbar';
import TwilioConnectedWrapper from '../TwilioConnectedWrapper';

const MobileOverlayContainer = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 auto;
  margin-top: 0;
  background-color: #FFF;
`;

const TransitionWrapper = styled.div<{ $in: boolean }>`
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: ${({ $in }) => ($in ? 0 : '100%')};
  transition: left 0.3s;
`;

const ConversationListWrapper = styled.div`
  height: calc(100% - ${POSITIONING.HEADER_HEIGHT});
  width: 100%;
  overflow-y: scroll;
  ${scrollBarStyles}
`;

const StyledTwilioConnectedWrapper = styled(TwilioConnectedWrapper)`
  height: 100%;
`;

const MobileChatOverlay = () => {
  const chatExpanded = useSelector(selectChatInterfaceState);
  const currentSelectedChat = useSelector(selectCurrentSelectedChat);

  const memoedConvList = useMemo(() => (!currentSelectedChat ? (
    <>
      <MobileChatHeader />
      <ConversationListWrapper>
        <ConversationList />
      </ConversationListWrapper>
    </>
  ) : null), [currentSelectedChat]);

  return (
    <Modal open={chatExpanded}>
      <Slide in={chatExpanded} direction="up" mountOnEnter unmountOnExit>
        <MobileOverlayContainer>
          <StyledTwilioConnectedWrapper>
            {memoedConvList}
            <TransitionWrapper $in={Boolean(currentSelectedChat)}>
              <ChatInterface mobile />
            </TransitionWrapper>
          </StyledTwilioConnectedWrapper>
          <ChatSnackbar />
        </MobileOverlayContainer>
      </Slide>
    </Modal>
  );
};

export default MobileChatOverlay;
